import {
  createUseFlags,
  type InitialFlagState as GenericInitialFlagState,
} from '@happykit/flags/client'
import { createUseFlagBag } from '@happykit/flags/context'
import { happykitConfig as config } from './config'

export type InitialFlagState = GenericInitialFlagState<{}>
export const useFlags = createUseFlags<{}>(config)
export const useFlagBag = createUseFlagBag<{}>()
